import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-gallery-page',
  templateUrl: './gallery-page.component.html',
  styleUrls: ['./gallery-page.component.scss']
})
export class GalleryPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
